import { Link } from 'react-router';
import '../moderation.scss';

export default function Denied() {
  return (
    <div className="Moderation__Denied">
      <div className="Moderation__Denied__Panel">
        <div className="Moderation__Denied__Icon" aria-hidden>
          🔒
        </div>
        <h1>You're not a moderator yet</h1>
        <p>This area is for enrolled moderators and admins only.</p>
        <Link to="/moderation/apply" className="Moderation__Denied__Cta">
          Apply to become a moderator →
        </Link>
      </div>
    </div>
  );
}
